<script setup lang="ts">
import { useAppStore } from "@/store/app";
import { UITag } from "@gohighlevel/ghl-ui";
import { useI18n } from "vue-i18n";
import BrowserFrame from "./BrowserFrame.vue";
import RealFormPreview from "./RealFormPreview.vue";
import SharePanel from "./SharePanel.vue";

const store = useAppStore();
const { t } = useI18n();
</script>

<template>
  <section data-testid="share-pane" class="share-pane">
    <div class="share-pane__preview share-pane__preview--scrollable integrate-preview-card">
      <div class="share-pane__preview-chip integrate-preview-chip">
        <UITag type="info" size="small" :bordered="false">
          {{ t("integrate.share.preview") }}
        </UITag>
      </div>
      <BrowserFrame>
        <div class="share-pane__page">
          <RealFormPreview
            layout="share"
            :form-width="store.formStyle.width"
            :form-height="store.formStyle.height"
          />
        </div>
      </BrowserFrame>
    </div>
    <SharePanel :url="store.integrateShareUrl" />
  </section>
</template>

<style scoped>
.share-pane {
  display: flex;
  min-width: 0;
  min-height: 0;
  height: 100%;
  flex: 1;
  gap: 12px;
  overflow: hidden;
}
.share-pane__preview--scrollable {
  min-height: 0;
  overflow-y: auto;
}
.share-pane__preview-chip {
  width: 100%;
}
.share-pane :deep(.browser-frame) {
  max-width: none;
  min-height: 0;
  flex: 1;
}
.share-pane :deep(.browser-frame--mobile) {
  width: min(100%, 390px);
  max-width: 390px;
}
.share-pane :deep(.browser-frame__content) {
  min-height: 0;
  height: calc(100% - 40px);
  padding: 0;
}
.share-pane__page {
  display: flex;
  min-height: 440px;
  height: 100%;
  box-sizing: border-box;
  padding: 32px;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  background: var(--base-white, #fff);
}
.share-pane__page :deep(.real-form-preview--share) {
  margin-block: auto;
}
@media (max-width: 1024px) {
  .share-pane {
    flex-direction: column;
    overflow-y: auto;
  }
  .share-pane :deep(.share-panel) {
    width: 100%;
    height: auto;
    flex: 0 0 auto;
    overflow: visible;
  }
  .share-pane__preview--scrollable {
    flex: 0 0 auto;
    overflow: visible;
  }
}
</style>
